/**
 * O ponto de aterrissagem: o que e meu, hoje.
 *
 * E o `DESTINO_PADRAO` do SSO. Nenhuma edicao em massa acontece aqui -- a tela
 * responde "o que eu faco agora" e manda para o lugar certo.
 *
 * `nav.section` nao pode ser vazia: o LeftSidebar renderiza o primeiro nivel
 * como secao, e folha na raiz vira rotulo cinza sem link. `nav.title` e CHAVE
 * de i18n (`components.settings.permissionManagement.menuList.<title>`), nao
 * texto -- e o rotulo da secao sai de outro caminho
 * (`components.settings.permissionManagement.<section>`), em outro arquivo.
 */
export const nav = {
    permissao: 'deck.meu-dia:ver',
    section: 'Trabalho',
    title: 'MeuDia',
    icon: 'today',
    route: '/meu-dia',
    sequence: 1,
};

export default [
    {
        path: '/meu-dia',
        name: 'meu-dia',
        component: () => import('./pages/MeuDiaPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.meu-dia:ver' },
    },
];
